document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const menuButton = document.querySelector('[data-menu-toggle]');
const mobileMenu = document.querySelector('[data-mobile-menu]');

if (menuButton && mobileMenu) {
  menuButton.addEventListener('click', () => {
    const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!isOpen));
    mobileMenu.hidden = isOpen;
    document.body.classList.toggle('menu-open', !isOpen);
  });
}

document.querySelectorAll('[data-faq-button]').forEach((button) => {
  button.addEventListener('click', () => {
    const item = button.closest('.faq-item');
    const isOpen = item.classList.toggle('is-open');
    button.setAttribute('aria-expanded', String(isOpen));
  });
});

const showQuantityMessage = (input, message) => {
  const quantity = input.closest('[data-quantity]');
  const messageElement = quantity ? quantity.parentElement.querySelector('[data-stock-message]') : null;
  if (!messageElement) return;
  messageElement.textContent = message || input.dataset.stockMessage || messageElement.textContent;
  messageElement.hidden = false;
  messageElement.classList.add('is-visible');
};

const hideQuantityMessage = (input) => {
  const quantity = input.closest('[data-quantity]');
  const messageElement = quantity ? quantity.parentElement.querySelector('[data-stock-message]') : null;
  if (!messageElement) return;
  messageElement.hidden = true;
  messageElement.classList.remove('is-visible');
};

const getExplicitQuantityLimit = (input) => {
  const rawMax = input.dataset.stockMax || input.getAttribute('max');
  if (rawMax === null || rawMax === '') return null;
  const max = Number(rawMax);
  return Number.isFinite(max) && max >= 0 ? max : null;
};

const inferSizeQuantityLimit = (input) => {
  const product = input.closest('[data-product]');
  const cartItem = input.closest('.cart-item');
  const text = [
    product ? product.querySelector('h1')?.textContent : '',
    product ? product.querySelector('.eyebrow')?.textContent : '',
    cartItem ? cartItem.querySelector('h2')?.textContent : '',
    cartItem ? cartItem.textContent : ''
  ].filter(Boolean).join(' ');

  if (/\bA5\b/i.test(text)) return 6;
  if (/\bA7\b/i.test(text)) return 5;
  return null;
};

const getQuantityLimit = (input) => {
  const explicitLimit = getExplicitQuantityLimit(input);
  return explicitLimit === null ? inferSizeQuantityLimit(input) : explicitLimit;
};

const updateQuantityDisplay = (input) => {
  const quantity = input.closest('[data-quantity]');
  const display = quantity ? quantity.querySelector('[data-quantity-display]') : null;
  if (display) display.textContent = input.value || '1';
};

const applyQuantityLimit = (input, limit = getQuantityLimit(input)) => {
  if (limit === null) return null;
  input.setAttribute('max', String(limit));
  input.dataset.stockMax = String(limit);
  return limit;
};

const getCartRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

const clampQuantityInput = (input) => {
  const min = Number(input.getAttribute('min') || 0);
  const max = getQuantityLimit(input);
  const current = Number(input.value || min);
  let next = Math.max(min, Number.isFinite(current) ? current : min);
  let limited = false;

  if (max !== null && next > max) {
    next = max;
    limited = true;
  }

  input.value = String(next);
  updateQuantityDisplay(input);
  if (limited) {
    showQuantityMessage(input);
  } else {
    hideQuantityMessage(input);
  }

  return limited;
};

document.querySelectorAll('[data-quantity]').forEach((quantity) => {
  const input = quantity.querySelector('input');
  if (!input) return;
  applyQuantityLimit(input);
  updateQuantityDisplay(input);

  quantity.querySelectorAll('button').forEach((button) => {
    button.addEventListener('click', () => {
      const change = button.dataset.action === 'increase' ? 1 : -1;
      const min = Number(input.getAttribute('min') || 1);
      const max = getQuantityLimit(input);
      const current = Math.max(min, Number(input.value || min) + change);
      const limitedByButton = max !== null && current > max;
      input.value = max === null ? current : Math.min(max, current);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      if (limitedByButton) showQuantityMessage(input);
    });
  });

  input.addEventListener('change', () => {
    clampQuantityInput(input);
  });
});

document.querySelectorAll('[data-variant-select]').forEach((select) => {
  select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    const product = select.closest('[data-product]');
    const idInput = product.querySelector('input[name="id"]');
    const price = product.querySelector('[data-product-price]');
    const compare = product.querySelector('[data-product-compare]');
    const saving = product.querySelector('[data-product-saving]');
    const submit = product.querySelector('button[name="add"]');
    if (idInput) idInput.value = option.value;
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }
    if (saving) {
      saving.textContent = option.dataset.saving || '';
      saving.hidden = !option.dataset.saving;
    }
    if (submit) {
      const available = option.dataset.available !== 'false';
      submit.disabled = !available;
    }
    const quantityInput = product.querySelector('input[name="quantity"]');
    if (quantityInput) {
      if (option.dataset.stockMax) {
        quantityInput.max = option.dataset.stockMax;
        quantityInput.dataset.stockMax = option.dataset.stockMax;
        quantityInput.dataset.stockMessage = option.dataset.stockMessage || '';
      } else {
        const fallbackMax = inferSizeQuantityLimit(quantityInput);
        if (fallbackMax === null) {
          quantityInput.removeAttribute('max');
          delete quantityInput.dataset.stockMax;
          delete quantityInput.dataset.stockMessage;
        } else {
          applyQuantityLimit(quantityInput, fallbackMax);
        }
      }
      clampQuantityInput(quantityInput);
    }
  });
});

document.querySelectorAll('.product-form').forEach((form) => {
  form.addEventListener('submit', () => {
    form.querySelectorAll('input[name="quantity"]').forEach((input) => {
      applyQuantityLimit(input);
      clampQuantityInput(input);
    });
  });
});

const cartForm = document.querySelector('[data-cart-form]');
if (cartForm) {
  const overStockUpdates = {};
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const updateButton = cartForm.querySelector('[data-cart-update-button]');
  const checkoutButton = cartForm.querySelector('[data-cart-checkout-button]');
  const originalUpdateButtonText = updateButton ? updateButton.textContent : '';
  const updatingText = cartForm.dataset.cartUpdatingText || originalUpdateButtonText || 'Updating...';
  const checkoutInitiallyDisabled = checkoutButton ? checkoutButton.disabled : false;
  let cartUpdateTimer;
  let cartUpdateController;

  const cartItems = () => Array.from(cartForm.querySelectorAll('[data-cart-item]'));
  const cartQuantityInputs = () => Array.from(cartForm.querySelectorAll('input[name="updates[]"]'));
  const inputForCartItem = (item) => item.querySelector('input[name="updates[]"]');

  const syncGiftBoxAddonQuantities = () => {
    const baseByGroup = new Map();
    const addonByGroup = new Map();

    cartItems().forEach((item) => {
      const group = item.dataset.giftBoxGroup;
      if (!group) return;
      if (item.dataset.giftBoxAddon === 'true') {
        addonByGroup.set(group, item);
      } else {
        baseByGroup.set(group, item);
      }
    });

    addonByGroup.forEach((addonItem, group) => {
      const baseItem = baseByGroup.get(group);
      const addonInput = inputForCartItem(addonItem);
      const baseInput = baseItem ? inputForCartItem(baseItem) : null;
      if (!addonInput || !baseInput) return;
      addonInput.value = baseInput.value;
      updateQuantityDisplay(addonInput);
    });
  };

  const setCartUpdating = (isUpdating) => {
    cartForm.dataset.cartUpdating = String(isUpdating);
    if (updateButton) {
      updateButton.disabled = isUpdating;
      updateButton.textContent = isUpdating ? updatingText : originalUpdateButtonText;
    }
    if (checkoutButton) {
      checkoutButton.disabled = checkoutInitiallyDisabled || isUpdating;
    }
  };

  const getCartUpdatePayload = () => {
    syncGiftBoxAddonQuantities();
    const updates = {};
    cartQuantityInputs().forEach((input) => {
      if (!input.dataset.lineKey) return;
      updates[input.dataset.lineKey] = Number(input.value || 0);
    });
    return updates;
  };

  const syncCartTotals = () => {
    const updates = getCartUpdatePayload();
    if (!Object.keys(updates).length) return;

    if (cartUpdateController) cartUpdateController.abort();
    cartUpdateController = new AbortController();
    setCartUpdating(true);

    fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates }),
      signal: cartUpdateController.signal
    }).then((response) => {
      if (!response.ok) throw new Error('Cart update failed');
      window.location.reload();
    }).catch((error) => {
      if (error.name === 'AbortError') return;
      setCartUpdating(false);
    });
  };

  const scheduleCartTotalsSync = () => {
    clearTimeout(cartUpdateTimer);
    setCartUpdating(true);
    cartUpdateTimer = setTimeout(syncCartTotals, 650);
  };

  cartQuantityInputs().forEach((input) => {
    applyQuantityLimit(input);
    const wasLimited = clampQuantityInput(input);
    input.dataset.lastSyncedValue = input.value;
    input.addEventListener('change', () => {
      syncGiftBoxAddonQuantities();
      if (input.value === input.dataset.lastSyncedValue) return;
      scheduleCartTotalsSync();
    });
    if (wasLimited && input.dataset.lineKey) {
      overStockUpdates[input.dataset.lineKey] = Number(input.value || 0);
    }
  });

  cartForm.addEventListener('submit', () => {
    cartQuantityInputs().forEach((input) => {
      applyQuantityLimit(input);
      clampQuantityInput(input);
    });
  });

  if (Object.keys(overStockUpdates).length) {
    fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: overStockUpdates })
    }).then((response) => {
      if (response.ok) window.location.reload();
    });
  } else {
    syncGiftBoxAddonQuantities();
  }
}

document.querySelectorAll('[data-product]').forEach((product) => {
  const gallery = product.querySelector('[data-product-gallery]');
  const lightbox = product.querySelector('[data-product-lightbox]');
  if (!gallery || !lightbox) return;

  const galleryItems = gallery.querySelectorAll('[data-gallery-item]');
  const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
  const triggers = gallery.querySelectorAll('[data-gallery-open]');
  const expandButton = gallery.querySelector('[data-gallery-expand]');
  const images = lightbox.querySelectorAll('[data-lightbox-image]');
  const closeButton = lightbox.querySelector('[data-lightbox-close]');
  const prevButton = lightbox.querySelector('[data-lightbox-prev]');
  const nextButton = lightbox.querySelector('[data-lightbox-next]');
  const canHoverZoom = window.matchMedia('(hover: hover) and (pointer: fine)');
  let activeIndex = 0;

  const showGalleryImage = (index) => {
    if (!galleryItems.length) return;
    activeIndex = (index + galleryItems.length) % galleryItems.length;
    galleryItems.forEach((item, itemIndex) => {
      const isActive = itemIndex === activeIndex;
      item.classList.toggle('is-active', isActive);
      if (!isActive) resetHoverZoom(item);
    });
    thumbs.forEach((thumb, thumbIndex) => {
      const isActive = thumbIndex === activeIndex;
      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  };

  const showImage = (index) => {
    if (!images.length) return;
    activeIndex = (index + images.length) % images.length;
    images.forEach((image, imageIndex) => {
      image.classList.toggle('is-active', imageIndex === activeIndex);
    });
  };

  const openLightbox = (index) => {
    showImage(index);
    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lightbox-open');
  };

  const closeLightbox = () => {
    lightbox.hidden = true;
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lightbox-open');
  };

  const resetHoverZoom = (trigger) => {
    trigger.classList.remove('is-zooming');
    trigger.style.removeProperty('--zoom-x');
    trigger.style.removeProperty('--zoom-y');
  };

  const moveHoverZoom = (event, trigger) => {
    if (!canHoverZoom.matches) return;
    const rect = trigger.getBoundingClientRect();
    const x = Math.min(100, Math.max(0, ((event.clientX - rect.left) / rect.width) * 100));
    const y = Math.min(100, Math.max(0, ((event.clientY - rect.top) / rect.height) * 100));
    trigger.style.setProperty('--zoom-x', `${x}%`);
    trigger.style.setProperty('--zoom-y', `${y}%`);
    trigger.classList.add('is-zooming');
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      openLightbox(Number(trigger.dataset.galleryIndex || 0));
    });
    trigger.addEventListener('mousemove', (event) => moveHoverZoom(event, trigger));
    trigger.addEventListener('mouseenter', (event) => moveHoverZoom(event, trigger));
    trigger.addEventListener('mouseleave', () => resetHoverZoom(trigger));
    trigger.addEventListener('blur', () => resetHoverZoom(trigger));
  });

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      showGalleryImage(Number(thumb.dataset.galleryIndex || 0));
    });
  });

  if (expandButton) {
    expandButton.addEventListener('click', () => {
      openLightbox(activeIndex);
    });
  }

  if (closeButton) closeButton.addEventListener('click', closeLightbox);
  if (prevButton) prevButton.addEventListener('click', () => showImage(activeIndex - 1));
  if (nextButton) nextButton.addEventListener('click', () => showImage(activeIndex + 1));

  lightbox.addEventListener('click', (event) => {
    if (event.target === lightbox) closeLightbox();
  });

  document.addEventListener('keydown', (event) => {
    if (lightbox.hidden) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowLeft') showImage(activeIndex - 1);
    if (event.key === 'ArrowRight') showImage(activeIndex + 1);
  });
});

const hideAcceleratedCheckout = () => {
  const hideNode = (node) => {
    if (!node || node.classList.contains('purchase-notes') || node.classList.contains('cod-hidden-payment')) return;
    node.hidden = true;
    node.setAttribute('aria-hidden', 'true');
    node.classList.add('cod-hidden-payment');
    node.style.setProperty('display', 'none', 'important');
    node.style.setProperty('visibility', 'hidden', 'important');
    node.style.setProperty('height', '0', 'important');
    node.style.setProperty('min-height', '0', 'important');
    node.style.setProperty('margin', '0', 'important');
    node.style.setProperty('padding', '0', 'important');
    node.style.setProperty('overflow', 'hidden', 'important');
  };

  document.querySelectorAll('.product-info').forEach((productInfo) => {
    const addButton = productInfo.querySelector('button[name="add"], .button--full');
    const stopSelector = '.purchase-notes, .order-steps';

    const hideFollowingSiblings = (node) => {
      let next = node ? node.nextElementSibling : null;
      while (next) {
        if (next.matches(stopSelector)) break;
        hideNode(next);
        next = next.nextElementSibling;
      }
    };

    let current = addButton;
    while (current && current !== productInfo) {
      hideFollowingSiblings(current);
      current = current.parentElement;
    }

    const selectors = [
      '.shopify-payment-button',
      '[data-shopify="payment-button"]',
      '.additional-checkout-buttons',
      '.dynamic-checkout__content',
      '.shopify-payment-button__button',
      '.shopify-payment-button__more-options',
      'paypal-buttons',
      'iframe[src*="paypal"]',
      '[id*="paypal"]',
      '[class*="paypal"]'
    ];

    productInfo.querySelectorAll(selectors.join(',')).forEach((element) => {
      hideNode(element.closest('.shopify-payment-button, [data-shopify="payment-button"], .additional-checkout-buttons, .dynamic-checkout__content') || element.parentElement || element);
    });

    productInfo.querySelectorAll('a').forEach((link) => {
      const text = (link.textContent || '').trim().toLowerCase();
      const href = link.getAttribute('href') || '';
      if (text.includes('more payment') || href === '#' || href.endsWith('#')) {
        hideNode(link);
      }
    });

    productInfo.querySelectorAll('button, div, section').forEach((element) => {
      const className = String(element.className || '').toLowerCase();
      const id = String(element.id || '').toLowerCase();
      const label = `${className} ${id}`;
      if (label.includes('paypal') || label.includes('shopify-payment') || label.includes('additional-checkout') || label.includes('dynamic-checkout')) {
        hideNode(element.closest('.shopify-payment-button, [data-shopify="payment-button"], .additional-checkout-buttons, .dynamic-checkout__content') || element.parentElement || element);
      }
    });
  });
};

hideAcceleratedCheckout();
setTimeout(hideAcceleratedCheckout, 250);
setTimeout(hideAcceleratedCheckout, 750);
setTimeout(hideAcceleratedCheckout, 1500);
setTimeout(hideAcceleratedCheckout, 3000);

document.querySelectorAll('.product-info').forEach((productInfo) => {
  const observer = new MutationObserver(hideAcceleratedCheckout);
  observer.observe(productInfo, { childList: true, subtree: true, attributes: true });
});
